/**
 * Синхронизация согласий на бэкенд после успешного логина (ФЗ-152).
 * Вызывать после login (Яндекс, Telegram, токен), когда accessToken уже в localStorage.
 */
import { createApiUrl } from '../config/api';
import { API_CONFIG } from '../config/api';
import {
  getRawPDConsentRecord,
  getRawCookieConsentRecord,
  isPDConsentSynced,
  isCookieConsentSynced,
  markPDConsentSynced,
  markCookieConsentSynced,
} from './pdConsent';

/**
 * Отправляет согласие на бэкенд. Не бросает ошибки — синхронизация не должна блокировать UX.
 */
export async function syncConsentToBackend(): Promise<void> {
  const accessToken = localStorage.getItem('accessToken');
  if (!accessToken) return;

  const url = createApiUrl(API_CONFIG.ENDPOINTS.API.CONSENT);

  // PD consent
  if (!isPDConsentSynced()) {
    const record = getRawPDConsentRecord();
    if (record) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          credentials: 'include',
          body: JSON.stringify({
            type: 'pd_consent',
            accepted: record.accepted,
            timestamp: record.timestamp,
          }),
        });
        if (res.ok) {
          markPDConsentSynced();
        }
      } catch {
        // Игнорируем — повторим при следующем логине
      }
    }
  }

  // Cookie consent (включая rejected)
  if (!isCookieConsentSynced()) {
    const record = getRawCookieConsentRecord();
    if (record) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          credentials: 'include',
          body: JSON.stringify({
            type: 'cookie_consent',
            accepted: record.accepted,
            timestamp: record.timestamp,
          }),
        });
        if (res.ok) {
          markCookieConsentSynced();
        }
      } catch {
        // Игнорируем
      }
    }
  }
}
